/**
 * Carousel Splitter
 *
 * Handles image upload to S3, subscription form, and download flow.
 * Reads config from <script type="application/json" id="carousel-config">.
 */

// Cookie helper functions
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

document.addEventListener('DOMContentLoaded', function() {
  const configEl = document.getElementById('carousel-config');
  if (!configEl) return;
  const config = JSON.parse(configEl.textContent);

  const form = document.getElementById('carousel-form');
  const fileInput = document.getElementById('image');
  const submitBtn = document.getElementById('submit-btn');
  const progressContainer = document.getElementById('progress-container');
  const progressBar = document.getElementById('progress-bar');
  const progressText = document.getElementById('progress-text');
  const s3KeyInput = document.getElementById('s3_key');
  const originalFilenameInput = document.getElementById('original_filename');
  const uploadZone = document.getElementById('upload-zone');

  // Handle subscription form if download_url is present
  if (config.downloadUrl) {
    const downloadUrl = config.downloadUrl;
    const subscriptionSection = document.getElementById('subscription-section');
    const downloadSection = document.getElementById('download-section');

    // Check if user has already submitted email via cookie
    const hasSubmittedEmail = getCookie('carousel_email_submitted') === 'true';

    if (hasSubmittedEmail) {
      // Skip email collection and go directly to download
      subscriptionSection.setAttribute('data-js-hidden', '');
      downloadSection.removeAttribute('data-js-hidden');
    }

    const subscriptionForm = document.getElementById('subscription-form');
    const subscribeBtn = document.getElementById('subscribe-btn');

    if (subscriptionForm && !hasSubmittedEmail) {
      subscriptionForm.addEventListener('submit', function(e) {
        e.preventDefault();

        const email = document.getElementById('subscriber-email').value.trim();
        const name = document.getElementById('subscriber-name').value.trim();

        if (!email) {
          alert('Please enter your email address.');
          return;
        }

        // Disable the button and show loading state
        subscribeBtn.disabled = true;
        subscribeBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Subscribing...';

        // Submit subscription
        fetch('/carousel/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email,
            name: name,
            download_url: downloadUrl
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            // Hide subscription form and show download section
            subscriptionSection.setAttribute('data-js-hidden', '');
            downloadSection.removeAttribute('data-js-hidden');
          } else {
            alert('Subscription failed: ' + data.message);
            // Re-enable the button
            subscribeBtn.disabled = false;
            subscribeBtn.innerHTML = '<i class="bi bi-envelope me-2"></i>Get My Download Link';
          }
        })
        .catch(error => {
          console.error('Subscription error:', error);
          alert('Something went wrong. Please try again.');
          // Re-enable the button
          subscribeBtn.disabled = false;
          subscribeBtn.innerHTML = '<i class="bi bi-envelope me-2"></i>Get My Download Link';
        });
      });
    }
  }

  // Upload zone interactivity
  if (!uploadZone) return;

  uploadZone.addEventListener('dragover', function(e) {
    e.preventDefault();
    uploadZone.style.borderColor = '#0d6efd';
    uploadZone.style.backgroundColor = 'rgba(13, 110, 253, 0.05)';
  });

  uploadZone.addEventListener('dragleave', function(e) {
    e.preventDefault();
    uploadZone.style.borderColor = '#dee2e6';
    uploadZone.style.backgroundColor = '';
  });

  uploadZone.addEventListener('drop', function(e) {
    e.preventDefault();
    uploadZone.style.borderColor = '#dee2e6';
    uploadZone.style.backgroundColor = '';

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      fileInput.files = files;
      updateUploadZone(files[0]);
    }
  });

  fileInput.addEventListener('change', function(e) {
    if (e.target.files.length > 0) {
      updateUploadZone(e.target.files[0]);
    }
  });

  function updateUploadZone(file) {
    const uploadContent = uploadZone.querySelector('.upload-content');
    uploadContent.innerHTML = `
      <i class="bi bi-file-image text-success mb-3 icon-3x"></i>
      <h5 class="fw-light mb-2">${file.name}</h5>
      <p class="text-muted mb-0">${(file.size / (1024 * 1024)).toFixed(1)} MB</p>
    `;
    uploadZone.style.borderColor = '#198754';
    uploadZone.style.backgroundColor = 'rgba(25, 135, 84, 0.05)';
  }

  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();

    const file = fileInput.files[0];
    if (!file) {
      // Highlight upload zone
      uploadZone.style.borderColor = '#dc3545';
      uploadZone.style.backgroundColor = 'rgba(220, 53, 69, 0.05)';
      setTimeout(() => {
        uploadZone.style.borderColor = '#dee2e6';
        uploadZone.style.backgroundColor = '';
      }, 2000);
      return;
    }

    const splitCount = document.querySelector('input[name="split_count"]:checked').value;

    // Start the upload process
    uploadToS3(file, splitCount);
  });

  function updateProgress(percent, text) {
    progressBar.style.width = percent + '%';
    progressText.textContent = text;
  }

  function uploadToS3(file, splitCount) {
    // Show progress
    progressContainer.removeAttribute('data-js-hidden');
    submitBtn.disabled = true;
    updateProgress(10, 'Getting upload credentials...');

    // Get presigned upload URL
    const params = new URLSearchParams({
      name: file.name,
      type: file.type
    });

    fetch('/carousel/upload?' + params.toString())
      .then(response => response.json())
      .then(formData => {
        updateProgress(20, 'Uploading image to S3...');
        return uploadFileToS3(file, formData);
      })
      .then(s3Key => {
        updateProgress(80, 'Processing image...');
        // Set form fields and submit for processing
        s3KeyInput.value = s3Key;
        originalFilenameInput.value = file.name;

        updateProgress(90, 'Splitting image...');
        // Submit the form for server-side processing
        form.submit();
      })
      .catch(error => {
        console.error('Upload error:', error);
        alert('Upload failed: ' + error.message);
        progressContainer.setAttribute('data-js-hidden', '');
        submitBtn.disabled = false;
      });
  }

  function uploadFileToS3(file, formData) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      const form = new FormData();

      // Add all the S3 form fields
      Object.keys(formData.fields).forEach(key => {
        form.append(key, formData.fields[key]);
      });

      // Add the file last
      form.append('file', file);

      xhr.upload.addEventListener('progress', function(event) {
        if (event.lengthComputable) {
          const percent = 20 + (event.loaded / event.total * 50); // 20-70%
          updateProgress(percent, `Uploading... ${Math.round(percent)}%`);
        }
      });

      xhr.addEventListener('load', function() {
        if (xhr.status === 204) {
          // Extract S3 key from the upload URL and fields
          const s3Key = formData.fields.key;
          resolve(s3Key);
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      });

      xhr.addEventListener('error', function() {
        reject(new Error('Network error during upload'));
      });

      xhr.open('POST', formData.url);
      xhr.send(form);
    });
  }
});
